import React from "react";
import { Lock } from "lucide-react";

/**
 * Locked: wraps content with a premium "blur veil" and a hover lock cue.
 * - select-none + pointer-events-none on inner content (cannot copy / open links)
 * - shimmer animation suggesting hidden value
 */
export function Locked({ children, className = "", testid }) {
  return (
    <span
      data-testid={testid}
      className={`relative inline-block align-baseline ${className}`}
    >
      <span
        aria-hidden="true"
        className="locked-veil select-none pointer-events-none"
        style={{
          filter: "blur(7px) saturate(1.1)",
          WebkitFilter: "blur(7px) saturate(1.1)",
          textShadow: "0 0 10px rgba(212,175,55,0.35)",
          opacity: 0.85,
        }}
      >
        {children}
      </span>
      {/* Shimmer overlay */}
      <span
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none locked-shimmer"
      />
    </span>
  );
}

export function LockBadge({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#D4AF37]/12 border border-[#D4AF37]/30 text-[10px] font-sans uppercase tracking-overline text-[#D4AF37] ${className}`}
    >
      <Lock className="w-2.5 h-2.5" />
      locked
    </span>
  );
}
